import { createStore } from 'vuex';

export default createStore({
  state: {
    hostname: 'www.german-films.de', // wird für fetch requests verwendet
    site: '/film-archive-1', // Wird für das Anpassen der URL beim bedienen der Seite gebraucht
    extensionName: 'tx_snmoviedb',
    pluginName: 'moviedb',
    dummyPicture: 'https://www.german-films.de/fileadmin/mediapool/IMAGES/Filmarchive/platzhalter_film_archive.jpg', // Bild das angezeigt wird wenn kein anderes vorhanden ist
    oldestFilm: '', // Erscheinungsjahr des ältesten Films, Benötigt für den Slider - wird automatisch gesetzt
    selectedFilmCard: 0, // ID des ausgewählten Films
    selectedPersonCard: 0, // ID der ausgewählten Person
    selectedCompanyCard: 0, // ID der ausgewählten Firma
    allGenres: [], // Alle verfügbaren Genres - werden aus der DB geladen
    allCategories: [], // Alle verfügbaren Kategorien - werden aus der DB geladen
    counter: 0, // Zählt wie oft man auf "show more" geklickt hat
    idForSearchRequest: [], // Liste mit Film-IDs die zur aktuellen Suche passen
    wholeDatabase: [], // Liste mit allen aktuell geladenen Filmen - wird nach und nach anhand von idForSearchRequest generiert
    company: null, // Daten zur aktuell ausgewählten Firma
    person: null, // Daten zur aktuell ausgewählten Person
    sortCriteria: 'title_en,title_de,asc', // Suchkriterium
    searchURL: '',
    fetchError: 0,
    completedLoading: false,
    vueURL: '',
    preview: false,
  },
  mutations: {
    updateSite(state, data) {
      this.state.site = data;
    },
    updateCompany(state, data) {
      this.state.company = data;
    },
    updatePerson(state, data) {
      this.state.person = data;
    },
    updateVueURL(state, data) {
      this.state.vueURL = data;
    },
    updateOldestFilm(state, data) {
      this.state.oldestFilm = data;
    },
    updateURL(state, URL) {
      // eslint-disable-next-line no-param-reassign
      state.searchURL = URL;
    },
    updatePreview(state, preview) {
      // eslint-disable-next-line no-param-reassign
      state.preview = preview;
    },
    async updateSelectedFilmCard(state, id) {
      let fetchSeperate = true;
      // eslint-disable-next-line consistent-return
      await this.state.wholeDatabase.forEach((film) => {
        if (film.uid === id || id === 0) {
          this.state.selectedFilmCard = id;
          fetchSeperate = false;
        }
      });
      if (fetchSeperate) {
        let urlPreview = '';
        if (state.preview) {
          urlPreview = '&tx_snmoviedb_moviedb[filter][preview]=true';
        }
        // eslint-disable-next-line no-param-reassign
        state.selectedFilmCard = 0;
        await fetch(
          `https://${state.hostname}/?${urlPreview}&tx_snmoviedb_moviedb[filter][answerType]=items&tx_snmoviedb_moviedb[items]=${id}&type=2753189517`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          },
        )
          .then((response) => response.json())
          .then(async (data) => {
            if (data.itemList[0].uid) {
              await state.wholeDatabase.push(data.itemList[0]);
              this.state.selectedFilmCard = id;
            } else {
              window.location.href = '/404';
            }
          }).catch(() => {
            // this.completeLoading(true);
            this.state.fetchError = 1;
          });
      }
    },
    async updateSelectedPersonCard(state, id) {
      if (id !== 0) {
        await fetch(
          `https://${state.hostname}/?tx_snmoviedb_moviedb[action]=special&tx_snmoviedb_moviedb[controller]=Film&tx_snmoviedb_moviedb[filter][answerType]=person&tx_snmoviedb_moviedb[person]=${id}&type=2753189517`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          },
        )
          .then((response) => response.json())
          .then(async (data) => {
            if (data.personFilmList.personData.firstname || data.personFilmList.personData.name) {
              this.state.person = data.personFilmList;
              this.state.selectedPersonCard = id;
            } else {
              console.log('fetch-error');
              window.location.href = '/404';
            }
          }).catch(() => {
            this.state.fetchError = 1;
          });
      } else {
        this.state.selectedPersonCard = id;
      }
    },
    async updateSelectedCompanyCard(state, id) {
      if (id !== 0) {
        await fetch(
          `https://${state.hostname}/?tx_snmoviedb_moviedb[action]=special&tx_snmoviedb_moviedb[controller]=Film&tx_snmoviedb_moviedb[filter][answerType]=company&tx_snmoviedb_moviedb[company]=${id}&type=2753189517`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          },
        )
          .then((response) => response.json())
          .then(async (data) => {
            if (data.companyFilmList.companyData.title) {
              this.state.company = data.companyFilmList;
              this.state.selectedCompanyCard = id;
            } else {
              window.location.href = '/404';
            }
          }).catch(() => {
            this.state.fetchError = 1;
          });
      } else {
        this.state.selectedCompanyCard = id;
      }
    },
    updateAllGenres(state, data) {
      this.state.allGenres = data;
    },
    updateAllCategories(state, data) {
      this.state.allCategories = data;
    },
    updateIdForSearchRequest(state, data) {
      this.state.idForSearchRequest = data;
    },
    updateCounter(state, data) {
      this.state.counter += data;
      if (data === 0) {
        this.state.counter = 0;
      }
    },
    async updateWholeDatabase(state, data) {
      /* eslint-disable no-param-reassign */
      await data.forEach((film) => {
        state.wholeDatabase.push(film);
        const filename = film.identifier;
        if (filename.length !== 0) {
          if (filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'jpeg'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'jpg'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'png'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'gif'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'bmp') {
            film.identifier = '';
          }
        }
      });
    },
    updateSortCriteria(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.sortCriteria = data;
    },
    clearEntries(state) {
      // eslint-disable-next-line no-param-reassign
      state.wholeDatabase = [];
    },
    updateError(state, error) {
      // eslint-disable-next-line no-param-reassign
      state.fetchError = error;
    },
    completeLoading(state, a) {
      // eslint-disable-next-line no-param-reassign
      state.completedLoading = a;
    },
  },
});
